import React from 'react'
import Button from "src/components/Button/Button"
import { useNavigate } from "react-router"
import './StickyButton.scss'
import ym from "react-yandex-metrika"

const StickyButton = () => {
    const navigate = useNavigate()

    return (
        <div className={"sticky__container"}>
            <Button
                className={"sticky__button"}
                onClick={() => {
                    ym('reachGoal', 'press_play_game')
                    navigate("/game")
                }}
            >
                Начать игру
            </Button>
        </div>
    )
}

export default StickyButton